(() => {
  'use strict';
  document.querySelectorAll('[data-occasion]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const buttons = [...section.querySelectorAll('[data-occasion-buy]')];
    const options = [...section.querySelectorAll('.occasion-options input')];
    const products = [...section.querySelectorAll('[data-occasion-product]')];
    const error = section.querySelector('[data-occasion-error]');
    const review = section.querySelector('[data-occasion-review]');
    const sticky = section.querySelector('[data-occasion-sticky]');
    const orderBlock = section.querySelector('.occasion-order');
    let orderVisible = true, pastFold = false;
    const syncSticky = () => { if (sticky) sticky.hidden = busy || uncertain || completed || orderVisible || !pastFold; };
    const root = section.dataset.root;
    const currency = section.dataset.currency;
    let busy = false, uncertain = false, completed = false;
    if (sticky && window.IntersectionObserver && orderBlock) {
      new window.IntersectionObserver(entries => { orderVisible = entries[0].isIntersecting; syncSticky(); }).observe(orderBlock);
    }
    if (sticky) {
      const onScroll = () => { pastFold = (window.scrollY || 0) > 400; syncSticky(); };
      window.addEventListener('scroll', onScroll, {passive: true});
      onScroll();
    }
    const positive = value => Number.isSafeInteger(value) && value > 0;
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(value / 100);
    const selected = () => options.find(option => option.checked && !option.disabled);
    const recipe = option => products.map(product => ({
      id:Number(product.dataset.variant), quantity:Number(product.dataset[option.value]), price:Number(product.dataset.price)
    }));
    const valid = option => option && /^[a-z0-9-]+$/.test(section.dataset.campaign || '') && /^\/(?:[^?#]*\/)?$/.test(root) && /^[A-Z]{3}$/.test(currency) &&
      ['starter','larger'].includes(option.value) && positive(Number(option.dataset.total)) &&
      products.length >= 2 && products.length <= 3 &&
      recipe(option).every(item => positive(item.id) && positive(item.quantity) && positive(item.price)) &&
      new Set(recipe(option).map(item => item.id)).size === products.length &&
      recipe(option).reduce((sum,item) => sum + item.quantity,0) === Number(option.dataset.packs) && Number(option.dataset.packs) <= 14 &&
      recipe(option).reduce((sum,item) => sum + item.quantity * item.price,0) === Number(option.dataset.total);
    const lock = value => {
      buttons.forEach(button => { button.disabled = value || !valid(selected()); });
      options.forEach(option => { if (option.dataset.unavailable !== 'true') option.disabled = value; });
    };
    options.forEach(option => { option.dataset.unavailable = String(option.disabled); });
    const update = () => {
      const option = selected();
      if (!valid(option)) { buttons.forEach(button => {button.disabled = true;}); return; }
      section.querySelectorAll('[data-display-total]').forEach(element => {element.textContent = money(Number(option.dataset.total));});
      section.querySelectorAll('[data-display-packs]').forEach(element => {element.textContent = option.dataset.packs;});
      products.forEach(product => {product.querySelector('[data-quantity]').textContent = product.dataset[option.value];});
      buttons.forEach(button => {button.disabled = busy || uncertain || completed;});
      syncSticky();
    };
    options.forEach(option => option.addEventListener('change',update));
    update();
    const read = async () => {
      const response = await window.fetch(root + 'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart_unavailable');
      const cart = await response.json();
      if (cart.currency !== currency || !positive(cart.item_count) && cart.item_count !== 0 || !Array.isArray(cart.items) ||
          cart.items.some(item => !item || !positive(item.quantity) || !positive(Number(item.variant_id)) || !Number.isSafeInteger(item.original_price) || !item.key) ||
          cart.items.reduce((sum,item) => sum + item.quantity,0) !== cart.item_count) throw new Error('cart_unreadable');
      return cart;
    };
    const inventory = items => {
      const counts = new Map();
      items.forEach(item => {
        const identity = JSON.stringify([Number(item.variant_id),item.original_price,item.selling_plan_allocation?.selling_plan?.id || null,Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))]);
        counts.set(identity,(counts.get(identity) || 0) + item.quantity);
      });
      return JSON.stringify([...counts].sort(([a],[b]) => a.localeCompare(b)));
    };
    const verify = (cart,before,marker,items) => {
      const added = cart.items.filter(item => item.properties?._tnm_occasion_selection === marker);
      return added.length === items.length && items.every(wanted => {
        const matching = added.filter(item => Number(item.variant_id) === wanted.id);
        return matching.length === 1 && matching[0].quantity === wanted.quantity &&
          matching[0].original_price === wanted.price && Number.isSafeInteger(matching[0].final_price) &&
          matching[0].final_price >= 0 && matching[0].final_price <= wanted.price &&
          matching[0].properties?._tnm_campaign === section.dataset.campaign &&
          !matching[0].selling_plan_allocation;
      }) && inventory(cart.items.filter(item => item.properties?._tnm_occasion_selection !== marker)) === inventory(before.items);
    };
    const finish = async (cart,before,marker,items) => {
      if (!verify(cart,before,marker,items)) return false;
      if (window.tnmHalloweenGiftGuard) {
        const safety = await window.tnmHalloweenGiftGuard.ensureSafe();
        if (!safety.safe || !verify(safety.cart,before,marker,items)) throw new Error('checkout_review_required');
      }
      completed = true;
      window.location.assign(root + 'checkout');
      return true;
    };
    buttons.forEach(button => button.addEventListener('click',async () => {
      const option = selected();
      if (busy || uncertain || completed || !valid(option)) return;
      const items = recipe(option);
      busy = true; lock(true); error.hidden = true; review.hidden = true;
      buttons.forEach(control => {control.setAttribute('aria-busy','true');control.textContent = section.dataset.busy;});
      let before, marker, sent = false, response;
      try {
        before = await read();
        marker = crypto.randomUUID();
        const properties = {_tnm_campaign:section.dataset.campaign,_tnm_occasion_selection:marker,_tnm_occasion_offer:option.value + '-v1'};
        const params = new URLSearchParams(window.location.search);
        ['utm_source','utm_campaign','utm_content'].forEach(key => {
          if (params.get(key)) properties['_tnm_' + key] = params.get(key).slice(0,150);
        });
        sent = true;
        response = await window.fetch(root + 'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(item => ({id:item.id,quantity:item.quantity,properties}))})});
        const after = await read();
        if (await finish(after,before,marker,items)) return;
        if (response.status >= 400 && response.status < 500 && inventory(after.items) === inventory(before.items)) sent = false;
        throw new Error('selection_unverified');
      } catch {
        uncertain = sent;
        if (sent && before && marker) {
          try {if (await finish(await read(),before,marker,items)) return;} catch {}
        }
        error.textContent = sent ? section.dataset.review : section.dataset.error;
        error.hidden = false; review.hidden = !sent; error.focus();
      } finally {
        busy = false;
        options.forEach(control => {if (control.dataset.unavailable !== 'true') control.disabled = false;});
        buttons.forEach(control => {control.removeAttribute('aria-busy');control.textContent = section.dataset.buyLabel;});
        lock(uncertain || completed);
        syncSticky();
      }
    }));
    section.querySelectorAll('[data-occasion-detail]').forEach(button => button.addEventListener('click',() => {
      const dialog = document.getElementById(button.dataset.occasionDetail);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }));
    section.querySelectorAll('.occasion-dialog').forEach(dialog => {
      dialog.querySelector('[data-occasion-close]').addEventListener('click',() => dialog.close());
      dialog.addEventListener('click',event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
    });
  });
})();
